import * as React from 'react';
import "../css/pc/CardListForStageTest.css";
import PropTypes from "prop-types";

export default function CardListForStageTest(props) {
  CardListForStageTest.propTypes = {
    cards: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      last4digits: PropTypes.string.isRequired,
      brand: PropTypes.string.isRequired,
    })
    ).isRequired,
    selectedCardId: PropTypes.number,
    onSelectedCardIdChange: PropTypes.func.isRequired,
  };
  
  CardListForStageTest.defaultProps = {
    selectedCardId: null,
  };

  return (
    <div className="card-list-container">
      <h2 className="card-list-title">Select a card</h2>
      
      <div className="cards-grid">
        {props.cards.map((card) => {
          const isSelected = props.selectedCardId === card.id;
          return (
            <div
              key={card.id}
              className={`card ${isSelected ? 'selected' : ''}`}
              onClick={() => props.onSelectedCardIdChange(card.id)}
            >
              <div className="card-content">
                <div className="card-brand">{card.brand}</div>
                <div className="card-number">{`****-****-****-${card.last4digits}`}</div>
              </div>
            </div>
          );
        })
        }
      </div>

    </div>
  );
}